

export default [
	{
		path: '',
		name: 'User',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserHome')
	},
	{
		path: 'bets',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets/index'),
		children: [
			{
				path: 'horse',
				name: 'UserBets',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets/HorseBets'),
				children:[
					{
						path: 'horse/:betId',
						name: 'UserBetsWithId',
						component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets/HorseBets'),
					}
				]
			},
			{
				path: 'sport',
				name: 'UserSportBets',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets/SportBets'),
				children:[
					{
						path: 'horse/:betId',
						name: 'UserSportBetsWithId',
						component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets/SportBets'),
					}
				]
			}
		]
	},
	{
		path: 'transactions',
		name: 'UserTransactions',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserTransactions')
	},
	{
		path: 'payin',
		//name: 'UserPayin',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayinPage'),
		children: [
			{
				path: '',
				name: 'UserPayin',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayin')
			},
			{
				path: ':status',
				name: 'UserPayinResponse',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayinResponse')
			}
		]
	},
	{
		path: 'payout',
		name: 'UserPayout',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayout')
	},
	{
		path: 'data',
		name: 'UserData',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserData/index')
	},
]
